/** CMS categorySlug -> frontend nav slug */
export const PRODUCT_SLUG_ALIASES = {
  'helium-leak-detector': 'helium-leak',
  'mass-spectrometer': 'mass-spectrometers',
  'gas-detector': 'gas-detectors',
  'leak-tester': 'airtightness',
  'leak-point-detector': 'bubble-leak',
  'test-platform': 'test-platforms'
}

export const REVERSE_PRODUCT_SLUG_ALIASES = Object.keys(PRODUCT_SLUG_ALIASES).reduce((acc, key) => {
  acc[PRODUCT_SLUG_ALIASES[key]] = key
  return acc
}, {})

export function normalizeProductSlug(slug) {
  return PRODUCT_SLUG_ALIASES[slug] || slug
}

export function cmsProductSlug(slug) {
  return REVERSE_PRODUCT_SLUG_ALIASES[slug] || slug
}

export function isSameProductSlug(a, b) {
  if (!a || !b) return false
  if (a === b) return true
  return normalizeProductSlug(a) === normalizeProductSlug(b) ||
    cmsProductSlug(a) === b ||
    cmsProductSlug(b) === a
}
